/* IN A BOX — core storefront JS. No dependencies. */
(function () {
  'use strict';
  var IAB = (window.IAB = window.IAB || {});

  /* ---------- analytics bus ----------
     One call fans out to: window.dataLayer (GTM/GA4), a DOM event (for any
     custom listener), and Shopify Customer Events (custom pixels for Meta
     Pixel/CAPI, GA4, etc. subscribe to 'iab_<name>'). */
  IAB.track = function (name, data) {
    data = data || {};
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'iab_' + name }, data)); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('iab:track', { detail: { name: name, data: data } })); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('iab_' + name, data); } catch (e) {}
  };

  IAB.money = function (cents) {
    var r = Math.round(cents / 100);
    return '₹' + r.toLocaleString('en-IN');
  };

  IAB.toast = function (msg, ms) {
    var t = document.createElement('div');
    t.className = 'iab-toast'; t.setAttribute('role', 'status'); t.textContent = msg;
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, ms || 2600);
  };

  IAB.esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };

  /* ---------- creator library ----------
     Loaded from /pages/creators?view=feed (paginated JSON, 50 per page),
     so the marketplace and configurator scale to thousands of creators. */
  IAB.loadCreators = function () {
    if (IAB._creators) return IAB._creators;
    var inline = document.getElementById('iab-creators-data');
    var base = (window.IAB_CONFIG && IAB_CONFIG.feedUrl) || '/pages/creators?view=feed';
    IAB._creators = new Promise(function (resolve) {
      var all = [];
      if (inline) {
        try { var d = JSON.parse(inline.textContent); all = d.items || []; if (!d.next) return resolve(all); } catch (e) {}
      }
      (function page(n) {
        fetch(base + (base.indexOf('?') > -1 ? '&' : '?') + 'page=' + n, { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (txt) {
            var d = JSON.parse(txt.trim());
            var seen = {}; all.forEach(function (c) { seen[c.id] = 1; });
            (d.items || []).forEach(function (c) { if (!seen[c.id]) all.push(c); });
            if (d.next && n < 40) page(n + 1); else resolve(all);
          })
          .catch(function () { resolve(all); });
      })(inline ? 2 : 1);
    }).then(function (list) {
      return list.filter(function (c) { return c.status !== 'Exclusive' && c.status !== 'Reserved' && c.available !== false; })
        .sort(function (a, b) { return (a.sort || 9999) - (b.sort || 9999); });
    });
    return IAB._creators;
  };

  IAB.creatorCard = function (c, opts) {
    opts = opts || {};
    var tags = (c.industries || []).slice(0, 3).join(' • ');
    var langs = (c.languages || []).join(' • ');
    var img = c.image ? '<img src="' + IAB.esc(c.image) + '" alt="' + IAB.esc(c.name + ' — AI-generated creator ' + c.id) + '" loading="lazy" width="600" height="800">' : '';
    if (opts.select) {
      return '<button type="button" class="iab-ccard" data-creator="' + IAB.esc(c.id) + '" aria-pressed="false">' +
        '<div class="iab-ccard__img">' + img + '<span class="iab-ccard__id">' + IAB.esc(c.id) + '</span>' +
        '<span class="iab-ccard__tick" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 12.5l4 4 8-9"/></svg></span></div>' +
        '<div class="iab-ccard__body"><p class="iab-ccard__name">' + IAB.esc(c.name) + '</p><p class="iab-ccard__meta">' + IAB.esc(tags) + '<br>' + IAB.esc(langs) + '</p></div></button>';
    }
    return '<a class="iab-ccard" href="' + IAB.esc(c.url) + '">' +
      '<div class="iab-ccard__img">' + img + '<span class="iab-ccard__id">' + IAB.esc(c.id) + '</span></div>' +
      '<div class="iab-ccard__body"><p class="iab-ccard__name">' + IAB.esc(c.name) + '</p><p class="iab-ccard__meta">' + IAB.esc(tags) + '<br>' + IAB.esc(langs) + '</p>' +
      '<span class="iab-ccard__cta">View creator <span aria-hidden="true">→</span></span></div></a>';
  };

  /* ---------- header ---------- */
  function initHeader() {
    var h = document.querySelector('[data-iab-header]');
    if (h) {
      var onScroll = function () { h.classList.toggle('is-stuck', window.scrollY > 4); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-iab-open]');
      if (open) {
        var d = document.getElementById(open.getAttribute('data-iab-open'));
        if (d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; open.setAttribute('aria-expanded', 'true'); var f = d.querySelector('button,a,input'); if (f) f.focus(); }
        return;
      }
      var close = e.target.closest('[data-iab-close]');
      if (close) {
        var dr = close.closest('.iab-drawer');
        if (dr) { dr.classList.remove('is-open'); document.body.style.overflow = ''; }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('.iab-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); document.body.style.overflow = ''; });
    });
    // current nav item
    var p = location.pathname;
    document.querySelectorAll('.iab-nav a').forEach(function (a) {
      var ap = a.getAttribute('href') || '';
      if (ap.length > 1 && ap.indexOf('#') !== 0 && p.indexOf(ap.split('#')[0]) === 0 && ap.split('#')[0] !== '/') a.setAttribute('aria-current', 'page');
    });
  }

  function refreshCart() {
    var el = document.querySelector('[data-iab-cart-count]');
    if (!el) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      el.textContent = c.item_count; el.hidden = !c.item_count;
    }).catch(function () {});
  }
  IAB.refreshCart = refreshCart;

  function initReveal() {
    var els = document.querySelectorAll('.iab-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* anchor links that point at the homepage (/#how) work from any page */
  function initAnchors() {
    document.querySelectorAll('a[href^="/#"]').forEach(function (a) {
      if (location.pathname === '/') a.setAttribute('href', a.getAttribute('href').slice(1));
    });
  }

  /* generic click tracking: data-iab-track="event_name" data-iab-data='{"k":"v"}' */
  function initClickTracking() {
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-iab-track]');
      if (!t) return;
      var data = {};
      try { data = JSON.parse(t.getAttribute('data-iab-data') || '{}'); } catch (x) {}
      IAB.track(t.getAttribute('data-iab-track'), data);
    });
  }

  /* page-level view events declared by templates: <meta name="iab-view" content="creator_marketplace_view"> */
  function pageView() {
    document.querySelectorAll('meta[name="iab-view"]').forEach(function (m) {
      var data = {};
      try { data = JSON.parse(m.getAttribute('data-iab-data') || '{}'); } catch (x) {}
      IAB.track(m.getAttribute('content'), data);
    });
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () { initHeader(); refreshCart(); initReveal(); initAnchors(); initClickTracking(); pageView(); });
})();
